import axios from 'axios';
import {notifications} from "@atttomyx/shared-utils";

export const loadPreferences = (success, failure) => {
    axios.get("/api/v1/notification/preferences")
        .then(response => {
            const json = response.data;

            json.deliveries = notifications.normalizeDeliveries(json.deliveries);
            json.topics = notifications.normalizeTopics(json.topics);

            success(json);
        })
        .catch(err => {
            failure(err);
        });
};

export const savePreferences = (preferences, success, failure) => {
    const url = "/api/v1/notification/preferences";

    axios.put(url, {
        messagingToken: preferences.messagingToken,
        deliveries: notifications.standardizeDeliveries(preferences.deliveries),
        topics: notifications.standardizeTopics(preferences.topics),
    })
        .then(response => {
            const json = response.data;

            json.deliveries = notifications.normalizeDeliveries(json.deliveries);
            json.topics = notifications.normalizeTopics(json.topics);

            success(json);
        })
        .catch(err => {
            failure(err);
        });
};
